import React, { useEffect, useState } from 'react';


import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import ImageMagnifier from "../components/ImageMagnifier"
import Pagination from '../components/Pagination';
import ViewerImage from '../components/ViewerImage';
import Bacner from '../components/home/Bacner';
import IframeVideo from '../components/home/IframeVideo';
import Story from '../components/home/Story';
import Product from '../components/home/Product';
import IframeVideo2 from '../components/home/IframeVideo2';
import TopBar from '../components/TopBar'
import Footer from '../components/Footer'
import { Fade, Slide } from "react-awesome-reveal";
import { addSubscription, productTypeListValue } from '../API';
import { message } from 'antd';
import { showLoding } from '../utils/tool';

function App() {

  const token = useSelector((state: any) => state?.token)

  const navigate = useNavigate()

  const [info, setVInfo]: any = useState()
  const handleVolunteerInfo = async () => { 
  }
  useEffect(() => {
  }, [token])

  const [categoryLi, setCategoryLi] = React.useState<any>([])
  const handleLoad = () => {
    productTypeListValue()
      .then((res) => {
        setCategoryLi(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }
  useEffect(() => {
    handleLoad()
  }, [])

  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const handleAddToCart = () => {
    if (!name || !phone) {
      message.error('請輸入姓名和電話號碼')
      return
    }
    showLoding(true)
    addSubscription({
      name: name,
      phone: phone,
    })
      .then((res) => {
        setName('')
        setPhone('')
        message.success('訂閱成功')
      })
      .catch((err) => {
        console.log(err)
      }).finally(() => {
        showLoding(false)
      })
  }

  return (
    <div>
      <TopBar />
      <Bacner />
      <div>
        <div className="grid gap-0 md:grid-cols-4 xl:grid-cols-7 pt-[90px] pb-[75px] h5:px-16">
          {
            categoryLi.map((item: any, index: number) => {
              return (
                <div
                  key={index}
                  onClick={() => {
                    navigate('/category' + '?id=' + item?.id)
                  }
                  }
                  className=" h5:flex h5:w-full cursor-pointer hover:-translate-y-1 duration-200">
                  <img src={item?.cfgValue}
                    className='w-[80%] mx-auto order-2 h5:w-[50%]'
                    alt="" />
                  <div className="pt-[20px] pb-[25px] text-[20px] order-1 flex-1 flex items-center justify-center relative">
                    {item?.cfgName}
                    <div className="absolute left-0 right-0 top-[49%] translate-y-0 w-full h-[52px] bg-[#f6f5f1] z-[-1] hidden h5:block"></div>
                  </div>
                </div>
              )
            })
          }    
        </div>
      </div>

      <div className='relative pb-[120px] h5:pb-[60px]'>
        < Slide triggerOnce >
          <div className="pt-[75px] text-[#181512] text-[40px] text-center font-[700] px-10 h5:text-[28px]">【全面7折 滿萬送千 再享 30期0利率! 】</div>
          <div className='pt-[30px] text-[#595959] text-[16px] text-center px-10 h5:text-[14px]'>詩肯柚木，我們力求家俱設計精美而又經久耐用。<br />
          我們的創始靈感來自北歐丹麥，注重簡約的設計以及家俱的實用性。<br />
          詩肯柚木一貫的理念，是要為繁忙的都市人營造一個舒適的居住空間。<br />
          我們深信，擁有自然優美光澤和紋理的柚木，配搭簡約的家具設計，可為現<br />
          代都市人打造出最完美的居家環境。</div>
        </ Slide >
        <IframeVideo />
        <div className="h-[364px] h5:h-[178px] absolute left-0 right-0 bottom-0 z-[-1]"
          style={{
            backgroundImage: `url(${require("../assets/image/icon6.png")})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
      </div>

      <div className="relative h-[840px] mt-[120px] h5:h-[546px] h5:mt-[40px] ">
        <img src={require("../assets/image/icon7.png")}
          className='absolute left-0 top-[120px] w-[540px] h-[540px]
          h5:w-[100%] h5:h-[360px] h5:top-[0px]
          '
          alt="" />
        <img src={require("../assets/image/icon8.jpg")}
          className='absolute left-[20px] top-[240px] w-[820px] h-[630px]
          h5:w-[90%] h5:h-auto h5:left-[5%] h5:top-[40px]
          '
          alt="" />
        <div className=" pt-[360px] h5:pt-[100px]">
          <div className="w-[1200px] mx-auto flex relative h5:w-full h5:pr-16">
            <div className="flex-1 h5:w-[40px]"></div>
            <div className="bg-[#f6f5f1] py-[76px] px-[100px] cursor-pointer hover:-translate-y-1 duration-200
             h5:p-[30px] h5:pr-[20px] h5:bg-[#f6f5f1]"
              onClick={() => navigate('/about/whyUs')}>
              <div className="text-[#8c8c8c] text-[24px] h5:text-[20px]">About</div>
              <div className="text-[#181512] text-[48px] font-bold h5:text-[30px]">SCANTEAK詩肯柚木</div>
              <div className="w-[394px] h-[4px] bg-[#0003] my-[30px] h5:w-[202px] h5:my-[20px]"></div>
              <div className="text-[#595959] text-[18px] mb-[24px] h5:text-[16px] h5:mb-[14px] h5:w-[280px]">營造舒適、溫馨的居家空間，是我們始終所追求的。</div>
              <div className="text-[#595959] text-[18px] mb-[24px] w-[570px] h5:mb-[14px] h5:text-[16px] h5:w-[280px]">
                將柚木家具的溫潤質感，注入美好日常。告別單調的生活空間，轉化為溫暖舒適的居住場所。連鎖家具領導品牌，詩肯柚木。</div>
              <div className="text-[#181512] text-[18px] font-bold cursor-pointer h5:text-[16px]">了解更多 {'>'}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative mt-[200px] h5:mt-[40px] h5:min-h-[840px]"
        style={{
          backgroundImage: `url(${require("../assets/image/icon7.png")})`,
          backgroundSize: "cover",
        }}
      >
        <img src={require("../assets/image/icon7.png")}
          className=' w-[70%] h5:hidden '
          alt="" />
        <div className="absolute top-[6%] left-0 right-0  ">
          <div className="w-[1200px] mx-auto flex h5:w-full h5:block">
            <div className="flex-1  hover:-translate-y-1 duration-200">
              <div className='h5:px-15'>
                <div className="pt-[75px] text-[#181512] text-[40px] font-[700] px-10 h5:pt-[0px] h5:text-[28px]">設計師系列</div>
                <div className="w-[394px] h-[4px] bg-[#0003] my-[30px] h5:w-[202px] h5:my-[20px]"></div>
                <div className="bg-[#fff] py-[50px] px-[50px] text-[18px] text-[#595959] cursor-pointer 
             h5:p-[30px] h5:pr-[20px] h5:bg-[#fff] h5:pb-[80px]"
                  onClick={() => navigate('/category?id=1009')}>
                  將『家』的理念發揚光大，詩肯家具集團與世界知名設計師團隊Outofstock共同開發原創設計。
                  <br />
                  融入空間、人、家具回歸設計最初本質，簡單才是最不簡單，細膩的體驗人們需求，從心出發的設計家具。
                  <br /><br />
                  <div className="w-[fit-content] pb-4 text-[18px] text-[#595959] h5:border-b border-dashed border-[#e0d9c6]">
                    瀏覽更多 {'>'}
                  </div>
                </div>
              </div>
            </div>
            <img src={require("../assets/image/icon9.png")}
              className=' w-[658px] relative left-[-40px] z-[-1] h5:w-[80%] h5:z-10 h5:top-[-50px] h5:left-[50%] translate-x-[-50%]'
              alt="" />
          </div>
        </div>
      </div>

      <div className='relative pb-[120px] h5:pb-[60px]'>
        < Slide triggerOnce >
          <div className="pt-[75px] text-[#181512] text-[40px] text-center font-[700] px-10 h5:text-[28px]">四季皆宜的柚木家具</div>
          <div className='pt-[30px] text-[#595959] text-[16px] text-center px-10 h5:text-[14px]'>
            打開家門你會發現，一切都美得恰到好處。<br /><br />
            全台百逾間服務據點，無壓力的暖心服務，讓您盡情想像未來家的樣貌，實踐生活的無限期待！</div>
        </ Slide >
        <IframeVideo2 />
        <div className="h-[364px] h5:h-[178px] absolute left-0 right-0 bottom-0 z-[-1]"
          style={{
            backgroundImage: `url(${require("../assets/image/icon6.png")})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
      </div>

      <div className='relative pb-[120px] h5:pb-[60px]'>
        < Slide triggerOnce >
          <div className="pt-[75px] text-[#181512] text-[40px] text-center font-[700] px-10 h5:text-[28px]">詩肯故事</div>
          <div className='pt-[30px] text-[#595959] text-[16px] text-center px-10 h5:text-[14px]'>
            詩肯柚木所製造的柚木家具品質一流，設計經典，歷久彌新。家具設計靈感來<br />
            自北歐丹麥，簡約質感線條及天然耐用柚木，是您營造溫馨舒適居住環境的理<br />
            想選擇。</div>
        </ Slide >
        <Story />
      </div>

      <div className='relative pb-[120px] h5:pb-[60px]'>
        < Slide triggerOnce >
          <div className="pt-[75px] text-[#181512] text-[40px] text-center font-[700] px-10 h5:text-[28px]">精選商品</div>
          <div className='pt-[30px] text-[#595959] text-[16px] text-center px-10 h5:text-[14px]'>
            入手詩肯柚木最佳時機。嚴選當月前五項熱銷商品主打推薦<br />
            最棒最實用的詩肯柚木家具，讓您的家溫馨獨特又有個性<br />
          </div>
        </ Slide >
        <Product />
      </div>

      <div className="py-[118px]"
        style={{
          backgroundImage: `url(${require("../assets/image/icon14.png")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }
        }
      >
        <div className="h5:p-[16px]">
          <div className="bg-white w-[770px] mx-auto rounded-sm p-[80px] h5:w-full h5:p-[30px]">
            <div className="text-[#181512] text-[20px] font-[700] h5:text-[18px]">訂閱我們</div>
            <div className="text-[#595959] text-[18px] mt-10 mb-[26px] h5:text-[16px]">只要填寫下方表格，您將可以不定期地獲得詩肯最新活動及專屬優惠訊息。</div>
            <div className="flex items-center h5:block">
              <div className="flex-1 flex bg-[#ececec] px-10 rounded-sm  "
                style={{
                  borderBottom: '1px solid #dfc397'
                }}
              >
                <input type="text" placeholder="姓名"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="flex-1 outline-none h-[55px] bg-transparent" />
              </div>
              <div className="w-[10px] h5:h-[16px]"></div>
              <div className="flex-1 flex bg-[#ececec] px-10 rounded-sm  "
                style={{
                  borderBottom: '1px solid #dfc397'
                }}
              >
                <input type="text" placeholder="電話號碼"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className="flex-1 outline-none h-[55px] bg-transparent" />
              </div>
            </div>
            <div className="flex justify-end pt-[30px]">
              <div className="bg-[#000] rounded-[4px] inline-block px-[50px] py-[16px] text-[#fff] text-[18px] cursor-pointer
                    hover:bg-[#666]
                    h5:w-full h5:text-center"
                onClick={() => {
                  handleAddToCart();
                }}
              >
                訂閱
              </div>
            </div>
          </div>
        </div>
      </div>




      {/* <ViewerImage
        images={[
          { src: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb', alt: '图片1' },
          { src: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png', alt: '图片2' },
        ]}
      /> */}
      {/* <ImageMagnifier
        src="https://images.unsplash.com/photo-1506744038136-46273834b3fb"
        alt="图片描述"
        zoomLevel={2.5}
        width={400}
        height={300}
      /> */}
      {/* <Pagination
        totalPages={100}
        currentPage={pageIndex}
        onPageChange={(page: number) => setPageIndex(page)}
      /> */}
      {/* up down left  right */}
      {/* <Fade cascade={true} direction="down" delay={800} duration={800}>
        <p>I will gently appear as I enter the viewport</p>
      </Fade> */}
      {/* < Slide triggerOnce >
        < p >我只会在你第一次看到我时播放动画</ p >
      </ Slide > */}
      <Footer />
    </div>
  );
}

export default App;
